import { minorUnitsPerMajor } from './formats.ts';

export function convertMinor(
  minorNative: number,
  nativeCode: string,
  displayCode: string,
  rates: Record<string, number> | null,
): number | null {
  if (nativeCode === displayCode) return minorNative;
  if (!rates) return null;
  const nativeRate = rates[nativeCode];
  const displayRate = rates[displayCode];
  if (typeof nativeRate !== 'number' || typeof displayRate !== 'number') return null;
  if (!Number.isFinite(nativeRate) || !Number.isFinite(displayRate) || nativeRate <= 0 || displayRate <= 0) return null;
  const majorNative = minorNative / minorUnitsPerMajor(nativeCode);
  const majorDisplay = majorNative * (displayRate / nativeRate);
  return Math.round(majorDisplay * minorUnitsPerMajor(displayCode));
}
